import { ComboPackageType } from "../../interfaces/ComboPackage";
import useAppStore from "../../store/AppStore";
import ComboPackageGroup from "./ComboPackageGroup";
import styles from "./ComboPackageGroupContainer.module.css";
export default function ComboPackageGroupContainer({
  data,
}: {
  data: ComboPackageType[];
}) {
  const { isDeviceMobile } = useAppStore();
  return (
    <div className={`vas-w-100 vas-py-2`}>
      <div
        className={`${
          styles.combo_group_card
        } vas-d-flex vas-gap-3 vas-position-relative vas-pb-3 ${
          isDeviceMobile ? "vas-flex-wrap vas-justify-content-center" : ""
        }`}
        style={{ overflowX: "auto" }}
      >
        {data.map((item: ComboPackageType, idx: number) => {
          return <ComboPackageGroup data={item} key={idx} />;
        })}
      </div>
    </div>
  );
}
